import { GridLegacy, Typography } from "@mui/material";
import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import FormControlledInputTC from "../../../components/Forms/FormControlledInputTC";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import { useFormContext, useWatch } from "react-hook-form";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";

function PercentageOffTotal() {
  const { menukaartVestigingId } = useFormContext();

  const third_party = useWatch({ name: "third_party" });
  const thirdPartyIsLightspeedK = third_party === "LIGHTSPEEDK";
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <GridLegacy container spacing={1}>
            <GridLegacy item xs={12}>
              <Typography variant={"h5"}>
                <TranslationWrapper
                  tDefault={"Percentage off of total"}
                  tKey={"voucherDef.percentage_off_total.PERCENTAGE_OFF_TOTAL"}
                />
              </Typography>
            </GridLegacy>
            <GridLegacy item xs={12}>
              <Typography>
                <TranslationWrapper
                  tDefault={"This will give a PERCENTAGE discount on the total price of the total ORDER."}
                  tKey={"voucherDefs.form.percentage_off_total.explanation"}
                />
              </Typography>
            </GridLegacy>

            <FormControlledInputTC
              fieldProps={{ disabled: thirdPartyIsLightspeedK }}
              name={"priceDiscountPercentage"}
              suffix={" %"}
              tDefault={"Price Discount Percentage"}
              tKey={"voucherDefs.form.algemeen.label.priceDiscountPercentage"}
              type={"number"}
            />

            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label, prijs as label_extra&per_page=250&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"freeProducts_JSON" + menukaartVestigingId}
              multiple
              name={"freeProducts_JSON"}
              tDefault={"Voucherproduct (in cash desk / on ticket)"}
              tKey={"voucherDefs.form.algemeen.label.voucherProduct"}
            />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam  as label, prijs as label_extra&per_page=250&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"onlyifProductsInBasket_JSON" + menukaartVestigingId}
              multiple
              name={"onlyifProductsInBasket_JSON"}
              tDefault={"Only allow discount when these products are in Shopping Basket"}
              tKey={"voucherDefs.form.algemeen.label.onlyifProduct"}
            />

            <FormSwitchTC
              name={"allowOnEveryOnlyifProduct"}
              tDefault={"allowOnEveryOnlyifProduct"}
              tKey={"voucherDefs.form.algemeen.label.allowOnEveryOnlyifProduct"}
            />
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default PercentageOffTotal;
